import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { SPACING } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';

/** Inset on every side of the sidebar while emulating, so its green border reads as an outline. */
export const SIDEBAR_EMULATION_MARGIN = SPACING['spacing-sm'];

export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const SIDEBAR_EXPANDED_WIDTH = 296;
export const SIDEBAR_COLLAPSED_WIDTH_WITH_SCROLLBAR = 80;
export const SIDEBAR_MOBILE_HEIGHT = 57;

/** Fixed so footer content doesn't reflow while the sidebar animates open. */
export const SIDEBAR_FOOTER_CONTENT_WIDTH = `calc(${SIDEBAR_EXPANDED_WIDTH}px - ${SPACING['spacing-2xl']} - ${SPACING['spacing-xl']})`;

export const SIDEBAR_STRINGS = appStrings.modules.backrsSidebar;
